// ============================================
// Fallback Performance Tracker — Client-Side
//
// Lightweight fire-and-forget tracker that writes
// per-call performance metrics to Firestore when
// the provider router uses a fallback provider.
//
// Writes to: _ops/model_degradation/performance_logs
// Read by:   fallbackPerformanceMonitor (Cloud Function)
// ============================================

import { collection, addDoc } from "firebase/firestore";
import { db } from "../firebase";
import { C_OPS, OPS_MODEL_DEGRADATION_PERF_LOGS } from "../../constants/collections";

interface FallbackPerfLog {
  skillId: string;
  provider: string;
  model: string;
  latencyMs: number;
  success: boolean;
  error?: string;
  timestamp: string;
}

/**
 * Track a fallback provider call's performance metrics.
 * Fire-and-forget — errors are logged but never thrown.
 */
export function trackFallbackPerformance(log: FallbackPerfLog): void {
  const ref = collection(db, C_OPS, ...OPS_MODEL_DEGRADATION_PERF_LOGS.split("/"));
  addDoc(ref, log).catch((err) => {
    console.warn("[FallbackPerfTracker] Write failed:", err?.message ?? err);
  });
}
